import styled from "styled-components";

// root container for the application
export default styled.div`
  min-height: 100vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  font-size: 1.6rem;
  max-width: 1512px;
  margin: 0 auto;
  width: 100%;
`;
